// === PRÉFÉRENCE DE MODE D'AFFICHAGE ===
// Permet à l'utilisateur de forcer un layout (mobile/desktop) au lieu
// de subir l'auto-détection. Persisté en localStorage. Lu par DeviceUtils
// pour court-circuiter `getDeviceType()` quand un override est actif.
//
// Une fois la préférence changée, un reload est nécessaire car GAME_W/GAME_H
// sont évalués à l'import du module MobileHelper.

export type DisplayMode = 'auto' | 'mobile' | 'desktop';

const STORAGE_KEY = 'deadtide_display_mode';

class _DisplayModeSettings {
  private mode: DisplayMode;

  constructor() {
    this.mode = this.load();
  }

  /** Retourne la préférence actuelle (auto par défaut). */
  getMode(): DisplayMode {
    return this.mode;
  }

  /** Change la préférence et la persiste. Reload nécessaire pour effet visuel. */
  setMode(mode: DisplayMode): void {
    this.mode = mode;
    this.save();
  }

  /**
   * Retourne le type d'appareil forcé par l'utilisateur, ou null si auto.
   * Consulté par `DeviceUtils.getDeviceType()` avant l'auto-détection.
   */
  getForcedDeviceType(): 'mobile' | 'desktop' | null {
    if (this.mode === 'mobile') return 'mobile';
    if (this.mode === 'desktop') return 'desktop';
    return null;
  }

  private load(): DisplayMode {
    try {
      const v = localStorage.getItem(STORAGE_KEY);
      if (v === 'mobile' || v === 'desktop' || v === 'auto') return v;
    } catch { /* localStorage indisponible */ }
    return 'auto';
  }

  private save(): void {
    try {
      localStorage.setItem(STORAGE_KEY, this.mode);
    } catch { /* localStorage plein ou indisponible */ }
  }
}

export const DisplayModeSettings = new _DisplayModeSettings();
